import React from 'react';
import { Field } from '@klarna/bubble-ui';
import { withTooltip } from './withTooltip';

function Input(props) {
  return <Field {...props} isUnderlined />;
}

export default withTooltip(Input);
